import React, { Component } from "react";
import "antd/dist/antd.css";
import { NavLink } from "react-router-dom";
import Profile from "../../Images/profile.png";
import {
  Row,
  Col,
  Dropdown,
  Layout,
  Menu,
  Button,
  message,
  Card,
  Popover,
  Divider,
} from "antd";
import { DownOutlined } from "@ant-design/icons";
import { withRouter } from "react-router";
import { withAppContext } from "../../store/contextStore";
import { Link } from "react-router-dom";
import AppConfigs from "../../Config/AppConfig";
import { Storage } from "aws-amplify";
import { list, update, deleteRecord } from "../../api/Apis";
// import bmpLogo from "../../Images/bmp-Logo.png";
import bmpLogo from "../../Images/newLogo.JPG";

import moment from "moment";

const { Meta } = Card;

class DriverHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opencart: false,
      cartLoading: false,
      cartData: [],
      visible: false,
      notifications: {},
      notificationsList: [],
      notificationsCount: 0,
      notificationVisible: false,
      profilePic: "",
      updateProfilePic: "",
    };
    this.changeMeasurementType = this.changeMeasurementType.bind(this);
  }
  onLogout = () => {
    this.props.context.dropUser();
    this.props.history.push("/login");
  };

  opencart = () => {
    this.setState({
      opencart: !this.state.opencart,
    });
  };

  componentDidMount = async () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    localStorage.setItem("cartData", JSON.stringify([]));
    if (userDetails && userDetails.userProfile === "CU") {
      this.getCartData();
    } else if (userDetails && userDetails.userProfile === "A") {
      this.getNotifications();
    }
    let profilePic = "";
    if (userDetails["profilePic"]) {
      profilePic = await Storage.get(userDetails["profilePic"]);
    }
    this.setState({
      profilePic: profilePic,
      updateProfilePic: userDetails["profilePic"],
    });
  };

  getNotifications = () => {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    let query = {
      orgId: orgDetails["id"],
      isActive: true,
    };
    list(AppConfigs["entityNames"]["notifications"], query).then((result) => {
      if (result.success) {
        let notifications = {},
          notificationsCount = 0;
        let notificationsData = result.data.sort((a, b) =>
          parseInt(a["createdAt"]) < parseInt(b["createdAt"]) ? 1 : -1
        );
        notificationsData.map((notification) => {
          let dayFormat =
            moment(notification["createdAt"]).format("dddd, DD MMMM") ===
            moment().format("dddd, DD MMMM")
              ? "Today"
              : moment(notification["createdAt"]).format("dddd, DD MMMM");
          if (dayFormat in notifications) {
            notifications[dayFormat].push(notification);
          } else {
            notifications[dayFormat] = [];
            notifications[dayFormat].push(notification);
          }
          notificationsCount += 1;
          return notification;
        });
        this.setState({
          notificationsList: result.data,
          notifications: notifications,
          notificationsCount: notificationsCount,
          pageLoadingStatus: false,
        });
      } else {
        this.setState({
          dataLoadingStatus: false,
        });
        console.log(result.errors);
      }
    });
  };

  getCartData = async () => {
    list(AppConfigs["getCartData"]).then(async (result) => {
      if (result.success) {
        let cartData = result.data;
        console.log(cartData);

        cartData.map(async (item) => {
          item["originalPath"] = item["image"];
          item["image"] = await Storage.get(item["image"]);
          this.setState({
            cartData: [...this.state.cartData, item],
          });
          this.props.context.setCartData(cartData);
          localStorage.setItem("cartData", JSON.stringify(cartData));
        });
      } else {
        console.log(result.errors);
        this.setState({
          dataLoadingStatus: false,
        });
      }
    });
  };
  quantityIncrement = (measurementType, quantity, itemId) => {
    if (measurementType === "Truckload" && parseInt(quantity) + 1 > 1) {
      message.error("Only 1 truckload can be ordered at a time.");
      return;
    }
    this.setState({
      cartLoading: true,
    });
    let data = {
      entityData: {
        quantity: quantity + 1,
      },
    };
    update(AppConfigs["entityNames"]["cart"], itemId, data).then((result) => {
      if (result.success) {
        // window.location.reload();
        this.setState({
          cartData: [],
          opencart: true,
          cartLoading: false,
        });
        this.getCartData();
      } else {
        console.log(result.errors);
      }
    });
  };
  quantityDecrement = (quantity, itemId) => {
    this.setState({
      cartLoading: true,
    });
    let data = {
      entityData: {
        quantity: quantity - 1,
      },
    };
    update(AppConfigs["entityNames"]["cart"], itemId, data).then((result) => {
      if (result.success) {
        this.setState({
          opencart: true,
          cartData: [],
          cartLoading: false,
        });
        this.getCartData();
      } else {
        console.log(result.errors);
      }
    });
  };

  changeMeasurementType = async (
    measurementType,
    itemId,
    quantity,
    totalAmt
  ) => {
    if (measurementType === "Truckload" && parseInt(quantity) > 1) {
      message.error("Only 1 truckload can be ordered at a time.");
      return;
    }
    // else if(measurementType === "Pallet" && totalAmt === 0){
    //   message.error('This product is currently not available by the pallet');
    //   return;
    // }
    this.setState({
      cartLoading: true,
    });
    let data = {
      entityData: {
        measurementType: measurementType,
      },
    };
    update(AppConfigs["entityNames"]["cart"], itemId, data).then((result) => {
      if (result.success) {
        this.setState({
          opencart: true,
          cartData: [],
          cartLoading: false,
        });
        this.getCartData();
      } else {
        console.log(result.errors);
      }
    });
  };

  deleteCartItem = async (itemId) => {
    this.setState({
      cartLoading: true,
    });

    deleteRecord(AppConfigs["entityNames"]["cart"], itemId).then((result) => {
      if (result.success) {
        message.success("Product deleted successfully");
        window.location.reload();
      } else {
        console.log(result.errors);
      }
    });
  };

  checkout = () => {
    let cartdata = this.state.cartData;
    console.log(cartdata);
    // console.log(cartdata[0]["measurementType"])
    if (cartdata[0]["totalAmt"] === 0) {
      message.error(
        "This product is currently not available by the " +
          cartdata[0]["measurementType"] +
          ""
      );
      return;
    } else {
      this.props.history.push("/app/stones/finishorder");
      this.setState({
        // opencart: false
        visible: false,
      });
    }
  };

  handleVisibleChange = (visible) => {
    this.setState({ visible });
  };

  notificationHandlechange = (notificationVisible) => {
    this.setState({ notificationVisible, notificationLoading: true });
  };

  openDeatilsPage = (recordType, recordId, id) => {
    this.setState({ notificationVisible: false });
    let recordIds = [];
    if (recordId) {
      recordIds = [id];
    } else {
      this.state.notificationsList.map((n) => {
        recordIds.push(n["id"]);
        return n;
      });
    }
    recordIds.map((notification) => {
      let data = {
        entityData: {
          isActive: false,
        },
      };
      update(
        AppConfigs["entityNames"]["notifications"],
        notification,
        data
      ).then((result) => {
        if (result.success) {
          console.log("remove");
        } else {
          console.log(result.errors);
        }
      });
      return notification;
    });
    this.setState({
      notifications: [],
      notificationsList: [],
      notificationsCount: 0,
    });
    // this.getNotifications();
    if (recordType === "order") {
      this.props.history.push("/app/loads/loaddetails/" + recordId);
    } else if (recordType === "carrier") {
      this.props.history.push("/app/carriers/carrierdetails/" + recordId);
    } else if (recordType === "customer") {
      this.props.history.push("/app/customers/customerdetails/" + recordId);
    } else if (recordType === "notifications") {
      this.props.history.push("/app/adminnotifications");
    }
  };

  render() {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const imageUrl = this.state.profilePic;
    const { Header } = Layout;
    const menu = (
      <Menu>
        <Menu.Item>
          <NavLink to="/app/profilesettings">Profile Settings</NavLink>
        </Menu.Item>
        <Menu.Item onClick={this.onLogout}>Log out</Menu.Item>
      </Menu>
    );

    return (
      <div>
        <Header className="header-driver">
          <Row>
            <Col
              xl={{ span: 4 }}
              lg={{ span: 4 }}
              md={{ span: 14 }}
              sm={{ span: 14 }}
              xs={{ span: 14 }}
            >
              <Link to="/app/loads">
                <img src={bmpLogo} className="header-Logo" alt="logo" />
              </Link>
            </Col>

            <Col
              md={{ span: 10 }}
              sm={{ span: 10 }}
              xs={{ span: 10 }}
              className="show-on-mobile"
            >
              <Col className="header-image">
                <Popover
                  placement="bottomRight"
                  content={
                    <div style={{ width: "200px" }}>
                      <Meta
                        avatar={
                          imageUrl ? (
                            <img
                              src={imageUrl}
                              className="header-image"
                              alt="Profile"
                              style={{ marginTop: "0px" }}
                            />
                          ) : (
                            <Button
                              shape="circle"
                              size="big"
                              block={true}
                              style={{
                                background: "#0E4D90",
                                color: "white",
                                height: "50px",
                              }}
                            >
                              {userDetails.firstName &&
                                userDetails.firstName.charAt(0).toUpperCase()}
                            </Button>
                          )
                        }
                        title={
                          userDetails.firstName
                            ? userDetails.firstName + " " + userDetails.lastName
                            : userDetails.fullName
                        }
                      />
                      <Divider
                        style={{
                          marginBottom: "1vw",
                          marginTop: "1vw",
                        }}
                      />
                      <p>
                        <Link
                          to={{
                            pathname: `app/profilesettings`,
                          }}
                          style={{
                            textDecoration: "none",
                            color: "black",
                            marginLeft: "1vw",
                          }}
                          onClick={this.handleLink}
                        >
                          Profile Settings
                        </Link>
                      </p>

                      <p
                        style={{
                          textDecoration: "none",
                          color: "black",
                          marginLeft: "1vw",
                          cursor: "pointer",
                        }}
                        onClick={this.onLogout}
                      >
                        Logout
                      </p>

                      {/* <Row
                        onClick={this.onLogout}
                        style={{ cursor: "pointer" }}
                      >
                        <Col>
                          <LogoutOutlined
                            style={{
                              color: "red",
                              fontSize: "18px",
                            }}
                          />
                        </Col>
                        <Col
                          style={{
                            color: "red",
                            fontSize: "16px",
                            marginLeft: "10px",
                            marginTop: "-5px",
                          }}
                        >
                          Logout
                        </Col>
                      </Row> */}
                    </div>
                  }
                  title={null}
                  trigger="hover"
                >
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      className="header-image"
                      alt="Profile"
                    />
                  ) : (
                    <Button
                      shape="circle"
                      size="big"
                      block={true}
                      style={{
                        background: "#0E4D90",
                        color: "white",
                        height: "50px",
                      }}
                    >
                      {userDetails.firstName &&
                        userDetails.firstName.charAt(0).toUpperCase()}
                    </Button>
                  )}
                </Popover>
              </Col>
            </Col>
            <Col
              xl={{ span: 20 }}
              lg={{ span: 20 }}
              md={{ span: 20 }}
              className="show-on-desktop"
            >
              <div>
                <Menu mode="horizontal" style={{ marginTop: "-2px" }}>
                  <Menu.Item
                    key="1"
                    style={{
                      marginTop: "52px",
                      fontWeight: "bold",
                      color: "#9DADBC",
                      border: "none",
                    }}
                  >
                    <NavLink
                      to="/app/driver/todo"
                      activeStyle={{
                        color: "#0E4D90",
                        borderBottom: "2px solid",
                      }}
                    >
                      TO DO
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item
                    key="2"
                    style={{
                      marginTop: "52px",
                      color: "#9DADBC",
                      fontWeight: "bold",
                      border: "none",
                    }}
                  >
                    <NavLink
                      to="/app/driver/done"
                      activeStyle={{
                        color: "#0E4D90",
                        borderBottom: "2px solid",
                      }}
                    >
                      DONE
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item
                    key="10"
                    style={{
                      float: "right",
                      fontSize: "20px",
                      background: "white",
                      color: "#0E4D90",
                      marginBottom: "25px",
                      marginTop: "25px",
                      border: "none",
                    }}
                  >
                    <Row>
                      {imageUrl ? (
                        <img
                          src={imageUrl}
                          style={{
                            marginRight: "5px",
                            border: "1px solid #7B8190",
                            borderRadius: "50%",
                            width: "50px",
                            height: "50px",
                          }}
                          alt="Profile"
                        />
                      ) : (
                        <img
                          src={Profile}
                          style={{
                            marginRight: "5px",
                            border: "1px solid #7B8190",
                            borderRadius: "50%",
                            width: "50px",
                            height: "50px",
                          }}
                          alt="Profile"
                        />
                      )}

                      <Dropdown overlay={menu}>
                        <span style={{ color: "#0e4d90" }}>
                          {userDetails["firstName"] +
                            " " +
                            userDetails["lastName"]}{" "}
                          <DownOutlined />
                        </span>
                      </Dropdown>
                    </Row>
                  </Menu.Item>
                </Menu>
              </div>
            </Col>
          </Row>
        </Header>
      </div>
    );
  }
}

export default withAppContext(withRouter(DriverHeader));
